import { Box, Typography } from "@mui/material";
import React from "react";
import whattodo from "../../assets/images/What we do.png";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Orangelogo from "../../assets/images/Orangelogo.png";
import Knowmorebtn from "../../components/button/Knowmorebtn";

const ThinkingHeading = () => {
  return (
    <Box
      sx={{
        maxWidth: { xs: "100%", sm: "1440px" },
        margin: "0 auto",
        marginTop: "2rem",
        display: "flex",
        flexDirection: { xs: "column-reverse", sm: "row" },
        padding: { xs: "0rem 1.8rem", sm: "0rem 3rem" },
        backgroundColor: "#ecebeb",
      }}
    >
      <Box
        sx={{
          width: { xs: "100%", sm: "50%" },
        }}
      >
        <Box
          sx={{
            width: "4rem",
            marginTop: { xs: "1rem", sm: "2rem" },
          }}
        >
          <img src={Orangelogo} alt="" width="100%" />
        </Box>
        <Typography
          sx={{
            color: "rgba(35, 35, 37, 1)", // Add your desired color here
            fontFamily: "Montserrat",
            fontSize: { xs: "0.8rem", sm: "1rem" },
            marginTop: "0.4rem",
            fontWeight: "400",
          }}
        >
          OUR THINKING
        </Typography>
        <Typography
          variant="h4"
          sx={{
            fontFamily: "Montserrat",
            fontSize: { xs: "1.4rem", sm: "1.6rem" },
            fontWeight: "500",
            marginTop: "0.8rem",
          }}
        >
          <span style={{ color: "rgba(255, 102, 0, 1)" }}>Articles </span> and
          {"  "}
          <span style={{ color: "rgba(255, 102, 0, 1)" }}>White Papers </span>
        </Typography>
      </Box>
    </Box>
  );
};

export default ThinkingHeading;
